import { render, staticRenderFns } from "./STableDetailPurchaseComp.vue?vue&type=template&id=e8e630fe&"
import script from "./STableDetailPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./STableDetailPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports